import type { LocationDto } from "@/lib/api";
import type { Location } from "@/types/telematics.types";

export function toLocation(dto: LocationDto): Location {
	return {
		coordinates: dto.coordinates,
		address: dto.address,
		addressLine1: dto.addressLine1,
		addressLine2: dto.addressLine2,
	};
}
